import './bootstrap';
import '../css/app.css';

import 'element-ui/lib/theme-chalk/index.css';

//draggable for Vue2
//https://github.com/SortableJS/Vue.Draggable
import draggable from "vuedraggable"

//An easy and clean VueJS 2.x wizard plugin
//https://github.com/xaksis/vue-good-wizard
import VueGoodWizard from 'vue-good-wizard';


import axios from 'axios'
import VueAxios from 'vue-axios'
//https://element.eleme.io/#/en-US/component/popover
import { Button, Popover } from 'element-ui'

if (process.env.NODE_ENV === 'production') {
    window.Vue = require('vue/dist/vue.min');
} else {
    window.Vue = require('vue/dist/vue');
}

Vue.use(VueAxios, axios)


Vue.component('draggable', draggable);



Vue.use(VueGoodWizard);

Vue.component('el-button', Button);
Vue.component('el-popover', Popover);

Vue.component('editable-players-list', require('./Components/editablePlayersList.vue').default);
Vue.component('tournament-creator', require('./Components/tournamentCreator.vue').default);
Vue.component('accept-results-list', require('./Components/acceptResultsList.vue').default);
Vue.component('panel-results-list', require('./Components/panelResultsList.vue').default);
Vue.component('preview-results-list', require('./Components/previewResultsList.vue').default);
Vue.component('preview-eliminator-results-list', require('./Components/previewEliminatorResultsList.vue').default);
Vue.component('tournament-registration-form', require('./Components/TournamentRegistrationForm.vue').default);
Vue.component('admin-registrations-table', require('./Components/AdminRegistrationsTable.vue').default);
Vue.component('admin-tournament-settings', require('./Components/AdminTournamentSettings.vue').default);

//editablePlayersList.vue

//import Vue from 'vue';
//import Vuetify from 'vuetify';
//import '@mdi/font/css/materialdesignicons.css'
//import 'vuetify/dist/vuetify.min.css';

/* import { createInertiaApp } from '@inertiajs/vue2';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m'; */

/* const vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
})
 */

// const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
// createInertiaApp({
//     title: (title) => `${title} - ${appName}`,
//     resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),

//     setup({ el, App, props, plugin }) {
//         // Add route function.
//         // Register Inertia
//         Vue.use(plugin);
//         Vue.use(ZiggyVue, Ziggy);
//         Vue.use(Vuetify);
//         return new Vue({ render: h => h(App, props), vuetify }).$mount(el);
//     },
//     progress: {
//         color: '#4B5563',
//     },
// });
